import { memo } from 'react';
import Button from 'components/commons/buttons/button/Button';
import { useDispatch, useSelector } from 'react-redux';
import { mapZoomState, updateZoom } from 'redux/slices/mapSlice';
import { ReactComponent as IcAdd } from 'resources/icons/Ic_Add.svg';
import { ReactComponent as IcLess } from 'resources/icons/Ic_Less.svg';

const ZoomControl = memo(function ZoomControl() {
  const dispatch = useDispatch();
  const zoom = useSelector(mapZoomState);
  return (
    <>
      <div className='zoom-control'>
        <Button
          ariaLabel='Mas zoom'
          icon={IcAdd}
          onClick={(e) => {
            dispatch(updateZoom(parseInt(zoom as any)+1));
            e?.preventDefault();
          }}
        />
        <hr />
        <Button
          ariaLabel='Menos zoom'
          icon={IcLess}
          onClick={(e) => {
            dispatch(updateZoom(parseInt(zoom as any)-1));
            e?.preventDefault();
          }}
        />
      </div>
    </>
  );
});

export default ZoomControl;
